/**
 * Canonical corner radii for the Apollo design system.
 *
 * A literal snapshot of Tailwind v3's default scale rather than a read from
 * `tailwindcss/defaultTheme`, so the tokens own their pixels. While Tailwind is still in the tree
 * these values back the same steps as its `rounded-*` utilities in legacy markup — a Tailwind major
 * that moves the scale would drift the two apart, so re-check this file on upgrade.
 */

export const borderRadius = {
  none: "0px",
  sm: "0.125rem",
  DEFAULT: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px",
};
